import type { Lang } from '../../../lib/i18n'
import type { OrderDetail } from '../../../lib/orders-api'
import { Badge } from '../../../components/ui/badge'
import { Ltr } from '../Ltr'
import { formatLbp, formatMoney } from '../format'
import { ot } from '../orders-i18n'
import { SectionCard } from './SectionCard'

interface Props {
  order: OrderDetail
  lang: Lang
}

export function TotalsSection({ order, lang }: Props) {
  const subtotal = order.items.reduce((sum, i) => sum + parseFloat(i.lineTotal || '0'), 0)
  const fee = order.appliedDeliveryFee ? parseFloat(order.appliedDeliveryFee) : 0

  return (
    <SectionCard title={ot(lang, 'totalsTitle')} lang={lang}>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>{ot(lang, 'subtotal')}</span>
          <Ltr>{formatMoney(subtotal, order.currency)}</Ltr>
        </div>
        {order.fulfillmentMethod === 'delivery' && (
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>{ot(lang, 'deliveryFee')}</span>
            <Ltr>{formatMoney(fee, order.currency)}</Ltr>
          </div>
        )}

        <div className="flex items-center justify-between border-t pt-2 text-base font-semibold text-foreground">
          <span>{ot(lang, 'grandTotal')}</span>
          <Ltr className="text-xl">{formatMoney(order.totalAmount, order.currency)}</Ltr>
        </div>
        {order.lbpAmount && (
          <div className="flex items-center justify-end text-sm text-muted-foreground">
            <Ltr>{formatLbp(order.lbpAmount)}</Ltr>
          </div>
        )}

        {order.fulfillmentMethod === 'delivery' && (
          <div className="mt-3 flex items-center justify-between rounded-lg border-2 border-navy bg-navy-tint px-4 py-3">
            <Badge variant="default" className="text-xs">{ot(lang, 'cod')}</Badge>
            <Ltr className="text-2xl font-bold text-navy">{formatMoney(order.totalAmount, order.currency)}</Ltr>
          </div>
        )}
      </div>
    </SectionCard>
  )
}
